import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";

export default function FocusedView({
  show,
  envelopeUrl,
  onClose,
  envelopeId,
  fetchAgreement
}) {

  const [sdkReady, setSdkReady] = useState(false);

  // Load DocuSign SDK
  useEffect(() => {

    if (window.DocuSign) {
      setSdkReady(true);
      return;
    }

    const script = document.createElement("script");
    script.src = process.env.REACT_APP_DOCUSIGN_SCRIPT_URL;
    script.async = true;

    script.onload = () => {
      console.log("DocuSign SDK Loaded");
      setSdkReady(true);
    };

    document.body.appendChild(script);

  }, []);



  useEffect(() => {

    if (!sdkReady || !envelopeUrl || !show) return;

    let signing;

    const startSigning = async () => {

      try {

        const docusign = await window.DocuSign.loadDocuSign();

        signing = docusign.signing({
          url: envelopeUrl,
          displayFormat: "focused",
          style: {
            height: "100%",
            width: "100%",
            border: "none",
            branding: {
              primaryButton: {
                backgroundColor: "#1175AB",
                color: "#ffffff"
              }
            },
            signingNavigationButton: {
              finishText: "Finish",
              position: "bottom-center"
            }
          }
        });

        signing.mount("#agreement");

        signing.on("sessionEnd", (event) => {

          console.log("DocuSign session ended");
        
          try {
            signing.unmount();
          } catch {}
        
          const container = document.getElementById("agreement");
          if (container) {
            container.innerHTML = "";
          }
        
          onClose();
        
          if (event.sessionEndType === "signing_complete") {
            fetchAgreement?.(envelopeId, "envelope");
          }
        
        });

      } catch (error) {
        console.error("DocuSign load error:", error);
      }
    };

    startSigning();

    return () => {
      try {
        signing?.unmount();
      } catch {}
    };

  }, [sdkReady, envelopeUrl, show]);



  return (
    <Modal
      show={show}
      size="xl"
      centered
      backdrop="static"
      keyboard={false}
      onHide={onClose}
    >
      <Modal.Header closeButton>
        <Modal.Title>Sign Agreement</Modal.Title>
      </Modal.Header>

      <Modal.Body
        style={{
          padding: 0,
          height: "80vh",
          display: "flex",
          flexDirection: "column"
        }}
      >

        {/* SCROLL CONTAINER */}
        <div
          style={{
            flex: 1,
            width: "100%",
            overflowX: "auto",
            overflowY: "hidden"
          }}
        >

          {/* INNER FIXED WIDTH CONTAINER */}
          <div
            style={{
              minWidth: "900px",
              height: "100%"
            }}
          >

            <div
              id="agreement"
              style={{
                height: "100%",
                width: "100%"
              }}
            />

          </div>

        </div>

      </Modal.Body>
    </Modal>
  );
}